import { InitialState } from '../state';
import { AppReducer } from './app-reducer';

export const timelineExportReducer: AppReducer<'TimelineExport'> = (
    state = InitialState.TimelineExport,
    action
): typeof state => {
    switch (action.type) {
        case 'TimelineExport/Load/Started':
            return {
                loading: true,
                success: false,
                url: '',
            };
        case 'TimelineExport/Load/Succeeded':
            return {
                loading: false,
                success: true,
                url: action.payload.url,
            };
        case 'TimelineExport/Load/Failed':
        case 'TimelineExport/Load/Unmounted':
            return {
                loading: false,
                success: false,
                url: '',
            };
        default:
            return state;
    }
};
